import { Cancel, Save } from "@mui/icons-material";
import { Box, CircularProgress, Tab } from "@mui/material";
import { Formik } from "formik";
import { isEmpty } from "lodash";
import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import Api from "../../api2";
import Helper from "../../helpers";
import { commonReducerSelector, userSelector } from "../../redux/selector";
import {
  MyBreadCrumbs,
  MyButton,
  MyForm,
  MyTable,
  MyThaoTac,
  ThongBao,
  scrollToError
} from "../Lib/componentLibrarys";
import { ValidateSchema } from "./validate";
import {
  FormBenhHai,
  FormNhap,
  FormPhanBon,
  FormThongTinLichSu,
  FormThuocTruSau
} from "./form";
import { parseDataSave, propsToInitialState } from "./models";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import Api_DanhMuc from "../../api_danhmuc";

const RoutesLichSuSanXuat = [
  {
    path: "",
    main: () => <LichSuSanXuat />
  },
  {
    path: "add",
    main: () => <HandleLichSuSanXuat />
  },
  {
    path: "edit/:id",
    main: () => <HandleLichSuSanXuat />
  }
];
export default RoutesLichSuSanXuat;

function LichSuSanXuat() {
  const [dataFormik, setFormik] = useState({
    search: "",
    limit: 10,
    anchor: 0
  });
  const [rawData, setRawData] = useState({});
  const [Count, setCount] = useState();
  const [data, setData] = useState([]);
  const formikRef = useRef();
  //for table method
  const navigate = useNavigate();

  const parseSearchForm = values => {
    const tuKhoa = values?.search?.length > 0 ? values?.search : "";
    const limit = values?.limit ? values.limit : 10;
    const anchor = values?.anchor ? values.anchor : 0;
    const page = values?.page || "";
    return { tuKhoa, limit, anchor, page };
  };

  useEffect(() => {
    const values = formikRef.current?.values;
    getApi(parseSearchForm(values));
  }, []);
  const getRows = (limit, anchor, page) => {
    const values = formikRef.current?.values;
    getApi(parseSearchForm({ ...values, limit, anchor, page }));
  };

  const getApi = ({ tuKhoa, limit, anchor, page }) => {
    new Api()
      .GetListLichSuSanXuat({ tuKhoa, limit, anchor })
      .then(res => {
        if (res.code === 200) {
          setData(
            Helper.addSttToTableDataSource(res.data.records, page, limit)
          );
          setRawData(res.data);
        }
        if (res.data?.count) {
          setCount(res.data?.count);
        }
      })
      .catch(err => {});
  };
  const onSubmitSearch = () => {
    const values = formikRef.current?.values;
    getApi(parseSearchForm(values));
  };
  const columns = ({ handleEdit, handleDelete }) => {
    var column = [
      {
        headerName: "STT",
        field: "stt",
        width: "100px",
        suppressSizeToFit: true,
        pinned: "left",
        cellStyle: { justifyContent: "center" },
        headerClass: "ag-grid-header-center"
      },
      {
        headerName: "Tên lô hàng",
        field: "tenLoHang",
        width: "300px"
      },
      {
        headerName: "Ngày gieo trồng",
        field: "ngayGieoTrong",
        width: "200px",
        cellStyle: { justifyContent: "center" },
        headerClass: "ag-grid-header-center",
        cellRenderer: prams => {
          return (
            <div>{Helper.formatDate(prams?.data?.ngayGieoTrong * 1000)}</div>
          );
        }
      },
      {
        headerName: "Ngày thu hoạch",
        field: "ngayThuHoach",
        width: "200px",
        cellStyle: { justifyContent: "center" },
        headerClass: "ag-grid-header-center",
        cellRenderer: prams => {
          return (
            <div>{Helper.formatDate(prams?.data?.ngayThuHoach * 1000)}</div>
          );
        }
      },
      { headerName: "Ghi chú", field: "ghiChu", minWidth: 200, flex: 1 },
      {
        headerName: "Thao tác",
        width: "100px",
        pinned: "right",
        cellStyle: { justifyContent: "center" },
        cellRendererFramework: prams => (
          <MyThaoTac
            prams={prams}
            handleDelete={handleDelete}
            handleEdit={handleEdit}
          />
        ),
        headerClass: "ag-grid-header-center"
      }
    ];
    return column;
  };

  const handleEdit = params => {
    if (!params?.id) {
      ThongBao({ status: "warn", message: "ID không tồn tại" });
    }
    navigate(`edit/${params?.id || undefined}`);
  };
  const handleAdd = data => {
    navigate(`add`);
  };
  const handleDelete = params => {
    new Api()
      .DeleteLichSuSanXuatById({ id: params?.id })
      .then(res => {
        if (res.code === 200) {
          const values = formikRef.current.values;
          getApi(parseSearchForm(values));
          ThongBao({ status: "success", message: "Xóa thành công" });
        }
      })
      .catch(err => {});
  };

  return (
    <div className="divMain">
      <MyBreadCrumbs
        title={[{ name: "Vận hành" }, { name: "Lịch sử sản xuất" }]}
      />
      <MyForm
        formikRef={formikRef}
        showSearch={true}
        dataFormik={dataFormik}
        handleAdd={handleAdd}
        editable={true}
        onSubmitAPI={onSubmitSearch}
        marginBottom={"15px"}
      />
      <MyTable
        autofit={true}
        columns={columns({
          editable: true,
          handleEdit: handleEdit,
          handleDelete: handleDelete
        })}
        data={data}
        pagination={{
          rawData: rawData,
          setData: setData,
          getRows: getRows,
          Count: Count
        }}
      />
    </div>
  );
}

function HandleLichSuSanXuat() {
  const navigate = useNavigate();
  const user = useSelector(userSelector);
  const [isLoading, setIsLoading] = useState(false);
  const { id } = useParams();
  const [data, setData] = useState(null);
  const common = useSelector(commonReducerSelector);
  const profile = common?.profile;
  const [page, setPage] = useState("thongTinLichSu");
  const handleChangePage = (event, value) => {
    if (value === "back") {
      navigate("/lichsusanxuat");
      return;
    }
    setPage(value);
  };
  const dataDanhMuc = common?.danhmucs?.data;
  const [loHangList, setLoHangList] = useState(null);
  const [loaiPhanBonList, setLoaiPhanBonList] = useState(null);
  const [loaiBenhHaiList, setLoaiBenhHaiList] = useState(null);
  const [loaiThuocTruSauList, setLoaiThuocTruSauList] = useState(null);

  const formRef = useRef(null);

  //ref just for use scroll when error validate
  const refI = useRef(null);

  useEffect(() => {
    if (id && !data) {
      setIsLoading(true);
      new Api()
        .GetLichSuSanXuatById({ id: id })
        .then(data => {
          if (data.code === 200) {
            setData(data?.data);
          }
        })
        .catch(err => {})
        .finally(() => {
          setIsLoading(false);
        });
    }
    if (isEmpty(loHangList)) {
      new Api().GetListLoHang({}).then(data => {
        if (data.code === 200) {
          setLoHangList(data?.data?.records);
        }
      });
    }
    if (isEmpty(loaiPhanBonList)) {
      new Api_DanhMuc().GetListPhanBons().then(data => {
        if (data.code === 200) {
          setLoaiPhanBonList(data?.data?.records);
        }
      });
    }
    if (isEmpty(loaiBenhHaiList)) {
      new Api_DanhMuc().GetListBenhHais().then(data => {
        if (data.code === 200) {
          setLoaiBenhHaiList(data?.data?.records);
        }
      });
    }
    if (isEmpty(loaiThuocTruSauList)) {
      new Api_DanhMuc().GetListThuocTruSaus().then(data => {
        if (data.code === 200) {
          setLoaiThuocTruSauList(data?.data?.records);
        }
      });
    }
  }, [id]);

  if (isLoading) {
    return (
      <div className="style-loading">
        <CircularProgress />
      </div>
    );
  }

  //set initial data
  const initialState = propsToInitialState(
    data,
    loHangList,
    loaiPhanBonList,
    loaiBenhHaiList,
    loaiThuocTruSauList
  );

  //handle when submit API
  const handleSave = async () => {
    await formRef.current.validateForm();

    if (!isEmpty(formRef.current.errors)) {
      scrollToError(refI);
      ThongBao({
        status: "warn",
        message: "Yêu cầu nhập đầy đủ các trường có dấu đỏ"
      });
      return;
    }

    new Api()
      .UpsertLichSuSanXuat({
        token: user.access_token,
        data: parseDataSave(formRef.current.values, profile)
      })
      .then(res => {
        if (!res || res.code !== 200) {
          //TODO
          ThongBao({ status: "error", message: "Đã có lỗi xảy ra" });
          return;
        }
        ThongBao({ status: "success", message: "Thành công" });
        navigate(-1);
      })
      .catch(err => {
        ThongBao({ status: "error", message: "Đã có lỗi xảy ra" });
      })
      .finally(() => {});
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          paddingBottom: "0.875rem"
        }}
      >
        <MyBreadCrumbs
          title={[
            { name: "Vận hành" },
            { name: "Lịch sử sản xuất", link: -1 },
            { name: `${id ? "Cập nhật " : "Thêm mới"}` }
          ]}
        />
        <Box sx={{ width: "100%", typography: "body1" }}>
          <TabContext value={page}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <TabList
                onChange={handleChangePage}
                aria-label="lab API tabs example"
              >
                <Tab
                  label="Thông tin lịch sử"
                  sx={{
                    textTransform: "none",
                    fontFamily:
                      '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif'
                  }}
                  value="thongTinLichSu"
                />
                <Tab
                  label="Phân bón"
                  sx={{
                    textTransform: "none",
                    fontFamily:
                      '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif'
                  }}
                  value="phanBon"
                />
                <Tab
                  label="Bệnh hại"
                  sx={{
                    textTransform: "none",
                    fontFamily:
                      '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif'
                  }}
                  value="benhHai"
                />
                <Tab
                  label="Thuốc trừ sâu"
                  sx={{
                    textTransform: "none",
                    fontFamily:
                      '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif'
                  }}
                  value="thuocTruSau"
                />

                <Tab
                  label="Trở lại"
                  sx={{
                    textTransform: "none",
                    color: "#2b713a",
                    fontFamily:
                      '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif',
                    textDecoration: "underline",
                    textUnderlineOffset: 4
                  }}
                  value="back"
                />
              </TabList>
            </Box>
            <Formik
              innerRef={f => (formRef.current = f)}
              initialValues={initialState}
              enableReinitialize={true}
              validateOnBlur={false}
              validateOnChange={false}
              validationSchema={ValidateSchema}
            >
              {({ values, errors, handleSubmit, setFieldValue }) => (
                <form onSubmit={handleSubmit}>
                  {/* div just for use scroll when error validate */}
                  <div ref={refI}></div>
                  <TabPanel
                    value="thongTinLichSu"
                    sx={{ height: "fit-content" }}
                  >
                    <FormThongTinLichSu
                      values={values}
                      errors={errors}
                      setFieldValue={setFieldValue}
                      loHangList={loHangList}
                    />
                  </TabPanel>
                  <TabPanel value="phanBon" sx={{ height: "fit-content" }}>
                    <FormPhanBon
                      values={values}
                      errors={errors}
                      setFieldValue={setFieldValue}
                      loaiPhanBonList={loaiPhanBonList}
                    />
                  </TabPanel>
                  <TabPanel value="benhHai" sx={{ height: "fit-content" }}>
                    <FormBenhHai
                      values={values}
                      errors={errors}
                      setFieldValue={setFieldValue}
                      loaiBenhHaiList={loaiBenhHaiList}
                    />
                  </TabPanel>
                  <TabPanel value="thuocTruSau" sx={{ height: "fit-content" }}>
                    <FormThuocTruSau
                      values={values}
                      errors={errors}
                      setFieldValue={setFieldValue}
                      loaiThuocTruSauList={loaiThuocTruSauList}
                    />
                  </TabPanel>
                </form>
              )}
            </Formik>
          </TabContext>
        </Box>
      </div>
      <div
        style={{
          display: "flex",
          position: "fixed",
          bottom: 20,
          right: 20
        }}
      >
        <MyButton
          onClick={() => navigate(-1)}
          txt="Hủy bỏ"
          color="#888"
          style={{ width: 130, height: 33, marginTop: 5 }}
          icon={<Cancel />}
        />
        <p style={{ width: 5 }}></p>
        <MyButton
          onClick={() => {
            handleSave();
          }}
          txt="Lưu thông tin"
          style={{ width: 130, height: 33, marginTop: 5 }}
          icon={<Save />}
        />
      </div>
    </>
  );
}
